import { lazy } from 'react'

import { RouteProps } from 'app/shared/types'

const AccountPassword = lazy(() => import('./account/password'))
const AccountProfile = lazy(() => import('./account/profile'))
const British = lazy(() => import('./british/British'))
const Home = lazy(() => import('./home'))
const SignIn = lazy(() => import('./membership/signin'))
const SignOut = lazy(() => import('./membership/signout'))
const VerifyAccount = lazy(() => import('./membership/verify-account'))

const AgendaReport = {
  Create: lazy(() => import('./agenda-report/create')),
  Detail: lazy(() => import('./agenda-report/detail')),
  List: lazy(() => import('./agenda-report/list')),
  Mobile: lazy(() => import('./agenda-report/mobile')),
  Stres: lazy(() => import('./agenda-report/stres')),
}

const BotClassification = {
  Create: lazy(() => import('./bot-classification/CreateBotClassification')),
  List: lazy(() => import('./bot-classification/BotClassificationList')),
  Update: lazy(() => import('./bot-classification/UpdateBotClassification')),
}

const BotControlSet = {
  Create: lazy(() => import('./bot-control-set/CreateBotControlSet')),
  List: lazy(() => import('./bot-control-set/BotControlSetList')),
  Update: lazy(() => import('./bot-control-set/UpdateBotControlSet')),
}

const BlackList = {
  Create: lazy(() => import('./black-list/CreateBlackList')),
  List: lazy(() => import('./black-list/BlackList')),
  Update: lazy(() => import('./black-list/UpdateBlackList')),
}

const TrainingSet = {
  List: lazy(() => import('./training-set/TrainingSet')),
  Update: lazy(() => import('./training-set/TrainingSetDetail')),
}

const TrainingTweet = {
  List: lazy(() => import('./training-tweet/TrainingTweet')),
}

const ClassificationCategory = {
  Create: lazy(
    () => import('./classification-category/CreateClassificationCategory')
  ),
  List: lazy(
    () => import('./classification-category/ClassificationCategoryList')
  ),
  Update: lazy(
    () => import('./classification-category/UpdateClassificationCategory')
  ),
}

const ClassificationControlSet = {
  Create: lazy(
    () => import('./classification-control-set/CreateClassificationControlSet')
  ),
  List: lazy(
    () => import('./classification-control-set/ClassificationControlSetList')
  ),
  Update: lazy(
    () => import('./classification-control-set/UpdateClassificationControlSet')
  ),
}

const ClassificationDataSet = {
  Create: lazy(
    () => import('./classification-data-set/CreateClassificationDataSet')
  ),
  List: lazy(
    () => import('./classification-data-set/ClassificationDataSetList')
  ),
  Update: lazy(
    () => import('./classification-data-set/UpdateClassificationDataSet')
  ),
}

const Definitions = {
  Create: lazy(() => import('./definition/CreateDefinition')),
  List: lazy(() => import('./definition/DefinitionList')),
  Detail: lazy(() => import('./definition/DetailDefinition')),
}

const DefinitionTag = {
  Create: lazy(() => import('./definition-tag/CreateDefinitionTag')),
  List: lazy(() => import('./definition-tag/DefinitionTagList')),
  Update: lazy(() => import('./definition-tag/UpdateDefinitionTag')),
}

const EntityCategoryType = {
  Create: lazy(() => import('./entity-category-type/CreateEntityCategoryType')),
  List: lazy(() => import('./entity-category-type/EntityCategoryTypeList')),
  Update: lazy(() => import('./entity-category-type/UpdateEntityCategoryType')),
}

const EntityType = {
  Create: lazy(() => import('./entity-type/CreateEntityType')),
  List: lazy(() => import('./entity-type/EntityTypeList')),
  Update: lazy(() => import('./entity-type/UpdateEntityType')),
}

const GenderControlSet = {
  Create: lazy(() => import('./gender-control-set/CreateGenderControlSet')),
  List: lazy(() => import('./gender-control-set/GenderControlSetList')),
  Update: lazy(() => import('./gender-control-set/UpdateGenderControlSet')),
}

const GenderDataSet = {
  Create: lazy(() => import('./gender-data-set/CreateGenderDataSet')),
  List: lazy(() => import('./gender-data-set/GenderDataSetList')),
  Update: lazy(() => import('./gender-data-set/UpdateGenderDataSet')),
}

const NamedEntityRecognition = {
  Create: lazy(
    () => import('./named-entity-recognition/CreateNamedEntityRecognition')
  ),
  List: lazy(
    () => import('./named-entity-recognition/NamedEntityRecognitionList')
  ),
  Update: lazy(
    () => import('./named-entity-recognition/UpdateNamedEntityRecognition')
  ),
}

const NamedEntityControlSet = {
  Create: lazy(
    () => import('./named-entity-control-set/CreateNamedEntityControlSet')
  ),
  List: lazy(
    () => import('./named-entity-control-set/NamedEntityControlSetList')
  ),
  Update: lazy(
    () => import('./named-entity-control-set/UpdateNamedEntityControlSet')
  ),
}

const PersonReport = {
  Create: lazy(() => import('./person-report/CreatePersonReport')),
  Detail: lazy(() => import('./person-report/DetailPersonReport')),
  Report: lazy(() => import('./person-report/Report')),
  Que: lazy(() => import('./person-report/PersonReportQueList')),
  Process: lazy(() => import('./person-report/ProcessPersonReport')),
  PdfReport: lazy(() => import('./person-report/PdfReport')),
  Pdf: lazy(() => import('./person-report/Pdf')),
}

const SentimentDataSet = {
  Create: lazy(() => import('./sentiment-data-set/CreateSentimentDataSet')),
  List: lazy(() => import('./sentiment-data-set/SentimentDataSetList')),
  Update: lazy(() => import('./sentiment-data-set/UpdateSentimentDataSet')),
}

const SentimentControlSet = {
  Create: lazy(
    () => import('./sentiment-control-set/CreateSentimentControlSet')
  ),
  List: lazy(() => import('./sentiment-control-set/SentimentControlSetList')),
  Update: lazy(
    () => import('./sentiment-control-set/UpdateSentimentControlSet')
  ),
}

const Source = {
  Create: lazy(() => import('./source/CreateSource')),
  List: lazy(() => import('./source/SourceList')),
  Update: lazy(() => import('./source/UpdateSource')),
}

const PartOfSpeech = {
  Create: lazy(() => import('./part-of-speech/CreatePartOfSpeech')),
  List: lazy(() => import('./part-of-speech/PartOfSpeechList')),
  Update: lazy(() => import('./part-of-speech/UpdatePartOfSpeech')),
}

const TrainingGroup = {
  Create: lazy(() => import('./training-group/CreateTrainingGroup')),
  List: lazy(() => import('./training-group/TrainingGroupList')),
  Update: lazy(() => import('./training-group/UpdateTrainingGroup')),
}

const BIToolWidget = {
  Create: lazy(() => import('./bi-tool/widget/create-widget')),
  List: lazy(() => import('./bi-tool/widget/widget-list')),
  Update: lazy(() => import('./bi-tool/widget/update-widget')),
}

const BIToolDashboard = {
  Create: lazy(() => import('./bi-tool/dashboard/create-dashboard')),
  List: lazy(() => import('./bi-tool/dashboard/dashboard-list')),
  Update: lazy(() => import('./bi-tool/dashboard/update-dashboard')),
  UpdateForSS: lazy(
    () => import('./bi-tool/dashboard/update-dashboard/index2')
  ),
}

const App = {
  Create: lazy(() => import('./identity-server/app/CreateApp')),
  List: lazy(() => import('./identity-server/app/AppList')),
  Update: lazy(() => import('./identity-server/app/UpdateApp')),
}

const Claim = {
  Create: lazy(() => import('./identity-server/claim/CreateClaim')),
  List: lazy(() => import('./identity-server/claim/ClaimList')),
  Update: lazy(() => import('./identity-server/claim/UpdateClaim')),
}

const User = {
  Create: lazy(() => import('./identity-server/user/CreateUser')),
  List: lazy(() => import('./identity-server/user/UserList')),
  Update: lazy(() => import('./identity-server/user/UpdateUser')),
}

const Role = {
  Create: lazy(() => import('./identity-server/role/CreateRole')),
  List: lazy(() => import('./identity-server/role/RoleList')),
  Update: lazy(() => import('./identity-server/role/UpdateRole')),
}

const InfluentialPeople = {
  List: lazy(() => import('./influential-people/InfluentialUserList')),
}
const NewsAlarms = {
  List: lazy(() => import('./news-alarms/NewsAlarmsList')),
}
const ManualAlarm = {
  Create: lazy(() => import('./manual-alarm/ManualAlarm')),
}
const NewsList = {
  List: lazy(() => import('./news-list/NewsList')),
  Update: lazy(() => import('./news-list/UpdateNewsList')),
}
const AgentaReport = {
  Create: lazy(() => import('./agenta-report-v2/create')),
  Detail: lazy(() => import('./agenta-report-v2/detail')),
  List: lazy(() => import('./agenta-report-v2/list')),
  Mobile: lazy(() => import('./agenta-report-v2/mobile')),
}

const GraphChart = lazy(
  () => import('./agenta-report-v2/widgets/graph-list/GraphList')
)

const routes: RouteProps[] = [
  {
    component: Home,
    path: ['/', '/home', '/dashboard'],
  },
  {
    component: AccountProfile,
    path: '/account/profile',
  },
  {
    component: AccountPassword,
    path: '/account/password',
  },
  {
    component: British,
    path: '/british',
  },
  {
    component: SignIn,
    path: '/signin',
    auth: 'public',
  },
  {
    component: SignOut,
    path: ['/signout', '/signout/:uid'],
    auth: 'public',
  },
  {
    component: VerifyAccount,
    path: '/verify-account',
    auth: 'public',
  },
  {
    component: BIToolWidget.Create,
    path: '/bi-tool/widget/create',
  },
  {
    component: BIToolWidget.Update,
    path: '/bi-tool/widget/update/:id',
  },
  {
    component: BIToolWidget.List,
    path: '/bi-tool/widgets',
  },
  {
    component: BIToolDashboard.Create,
    path: '/bi-tool/dashboard/create',
  },
  {
    component: BIToolDashboard.Update,
    path: '/bi-tool/dashboard/update/:id',
  },
  {
    component: BIToolDashboard.UpdateForSS,
    path: '/bi-tool/dashboard/updateForSS/:id',
  },
  {
    component: BIToolDashboard.List,
    path: '/bi-tool/dashboards',
  },
  {
    component: AgendaReport.Create,
    path: '/agenda-report/create',
  },
  {
    component: AgendaReport.Detail,
    path: '/agenda-report/detail/:id',
  },
  {
    component: AgendaReport.List,
    path: '/agenda-report',
  },
  {
    component: AgendaReport.Mobile,
    path: '/agenda-report/mobile',
  },
  {
    component: AgendaReport.Stres,
    path: '/agenda-report/stres',
  },
  {
    component: BotClassification.Create,
    path: '/bot-classification/create',
  },
  {
    component: BotClassification.Update,
    path: '/bot-classification/update/:id',
  },
  {
    component: BotClassification.List,
    path: '/bot-classification',
  },
  {
    component: BotControlSet.Create,
    path: '/bot-control-set/create',
  },
  {
    component: BotControlSet.Update,
    path: '/bot-control-set/update/:id',
  },
  {
    component: BotControlSet.List,
    path: '/bot-control-set',
  },
  {
    component: BlackList.Create,
    path: '/black-list/create',
  },
  {
    component: BlackList.Update,
    path: '/black-list/update/:id',
  },
  {
    component: BlackList.List,
    path: '/black-list',
  },
  {
    component: ManualAlarm.Create,
    path: '/manual-alarm/Create',
  },
  {
    component: TrainingSet.List,
    path: '/training-set',
  },
  {
    component: TrainingSet.Update,
    path: '/training-set-detail/:id/:type',
  },
  {
    component: TrainingTweet.List,
    path: '/training-tweet',
  },
  {
    component: ClassificationCategory.Create,
    path: '/classification-category/create',
  },
  {
    component: ClassificationCategory.Update,
    path: '/classification-category/update/:id',
  },
  {
    component: ClassificationCategory.List,
    path: '/classification-category',
  },
  {
    component: ClassificationControlSet.Create,
    path: '/classification-control-set/create',
  },
  {
    component: ClassificationControlSet.Update,
    path: '/classification-control-set/update/:id',
  },
  {
    component: ClassificationControlSet.List,
    path: '/classification-control-set',
  },
  {
    component: ClassificationDataSet.Create,
    path: '/classification-data-set/create',
  },
  {
    component: ClassificationDataSet.Update,
    path: '/classification-data-set/update/:id',
  },
  {
    component: ClassificationDataSet.List,
    path: '/classification-data-set',
  },
  {
    component: Definitions.Create,
    path: '/definition/create',
  },
  {
    component: Definitions.List,
    path: '/definition',
  },
  {
    component: Definitions.Detail,
    path: '/definition/detail/:id',
  },
  {
    component: DefinitionTag.Create,
    path: '/definition-tag/create',
  },
  {
    component: DefinitionTag.List,
    path: '/definition-tag',
  },
  {
    component: DefinitionTag.Update,
    path: '/definition-tag/update/:id',
  },
  {
    component: EntityCategoryType.Create,
    path: '/entity-category-type/create',
  },
  {
    component: EntityCategoryType.Update,
    path: '/entity-category-type/update/:id',
  },
  {
    component: EntityCategoryType.List,
    path: '/entity-category-type',
  },
  {
    component: EntityType.Create,
    path: '/entity-type/create',
  },
  {
    component: EntityType.Update,
    path: '/entity-type/update/:id',
  },
  {
    component: EntityType.List,
    path: '/entity-type',
  },
  {
    component: GenderControlSet.Create,
    path: '/gender-control-set/create',
  },
  {
    component: GenderControlSet.Update,
    path: '/gender-control-set/update/:id',
  },
  {
    component: GenderControlSet.List,
    path: '/gender-control-set',
  },
  {
    component: GenderDataSet.Create,
    path: '/gender-data-set/create',
  },
  {
    component: GenderDataSet.Update,
    path: '/gender-data-set/update/:id',
  },
  {
    component: GenderDataSet.List,
    path: '/gender-data-set',
  },
  {
    component: NamedEntityRecognition.Create,
    path: '/named-entity-recognition/create',
  },
  {
    component: NamedEntityRecognition.Update,
    path: '/named-entity-recognition/update/:id',
  },
  {
    component: NamedEntityRecognition.List,
    path: '/named-entity-recognition',
  },
  {
    component: NamedEntityControlSet.Create,
    path: '/named-entity-control-set/create',
  },
  {
    component: NamedEntityControlSet.Update,
    path: '/named-entity-control-set/update/:id',
  },
  {
    component: NamedEntityControlSet.List,
    path: '/named-entity-control-set',
  },
  {
    component: PersonReport.Report,
    path: '/report/:id',
  },
  {
    component: PersonReport.Create,
    path: '/person-report/create',
  },
  {
    component: PersonReport.Detail,
    path: '/person-report/detail/:id',
  },
  {
    component: PersonReport.Que,
    path: '/person-report',
  },
  {
    component: PersonReport.PdfReport,
    path: '/person-report/pdf-report/:id',
  },
  {
    component: PersonReport.Pdf,
    path: '/person-report/pdf',
  },
  {
    component: PersonReport.Process,
    path: '/person-report/process/detail/:id',
  },
  {
    component: SentimentDataSet.Create,
    path: '/sentiment-data-set/create',
  },
  {
    component: SentimentDataSet.Update,
    path: '/sentiment-data-set/update/:id',
  },
  {
    component: SentimentDataSet.List,
    path: '/sentiment-data-set',
  },
  {
    component: SentimentControlSet.Create,
    path: '/sentiment-control-set/create',
  },
  {
    component: SentimentControlSet.Update,
    path: '/sentiment-control-set/update/:id',
  },
  {
    component: SentimentControlSet.List,
    path: '/sentiment-control-set',
  },
  {
    component: PartOfSpeech.Create,
    path: '/part-of-speech/create',
  },
  {
    component: PartOfSpeech.List,
    path: '/part-of-speech',
  },
  {
    component: PartOfSpeech.Update,
    path: '/part-of-speech/update/:id',
  },
  {
    component: Source.Create,
    path: '/source/create',
  },
  {
    component: Source.List,
    path: '/source',
  },
  {
    component: Source.Update,
    path: '/source/update/:id',
  },
  {
    component: TrainingGroup.List,
    path: '/training-group',
  },
  {
    component: TrainingGroup.Create,
    path: '/training-group/create',
  },
  {
    component: TrainingGroup.Update,
    path: '/training-group/update/:id',
  },
  {
    component: App.Create,
    path: '/app/create',
  },
  {
    component: App.List,
    path: '/apps',
  },
  {
    component: App.Update,
    path: '/app/update/:id',
  },
  {
    component: Claim.Create,
    path: '/claim/create',
  },
  {
    component: Claim.List,
    path: '/claims',
  },
  {
    component: Claim.Update,
    path: '/claim/update/:id',
  },
  {
    component: User.Create,
    path: '/user/create',
  },
  {
    component: User.List,
    path: '/users',
  },
  {
    component: User.Update,
    path: '/user/update/:id',
  },
  {
    component: Role.Create,
    path: '/role/create',
  },
  {
    component: Role.List,
    path: '/roles',
  },
  {
    component: Role.Update,
    path: '/role/update/:id',
  },
  { component: InfluentialPeople.List, path: '/influential-people' },
  {
    component: NewsList.Update,
    path: '/news-list/update/:id',
  },
  {
    component: NewsList.List,
    path: '/news-list',
  },
  {
    component: NewsAlarms.List,
    path: '/news-alarms',
  },

  {
    component: AgentaReport.Create,
    path: '/agenda-report/agenda-reportv2/create',
  },
  {
    component: AgentaReport.Detail,
    path: '/agenda-report/agenda-reportv2//detail/:id',
  },
  {
    component: AgentaReport.List,
    path: '/agenda-report/agenda-reportv2',
  },
  {
    component: AgentaReport.Mobile,
    path: '/agenda-report/agenda-reportv2/mobile',
  },
  {
    component: GraphChart,
    path: '/graph-chart',
  },
]

export default routes
